<script>
  export default {
    name: 'OperationButtons',
    props: {
      // 当前步骤索引
      currentIndex: {
        type: Number,
        default: 0
      },
      // 总步骤数
      totalSteps: {
        type: Number,
        default: 1
      },
      // 是否显示保存草稿按钮
      showSaveDraft: {
        type: Boolean,
        default: true
      },
      // 是否是编辑模式
      isEdit: {
        type: Boolean,
        default: false
      },
      // 取消按钮文案
      cancelText: {
        type: String,
        default: '取消新增'
      }
    },
    computed: {
      // 是否是第一步
      isFirstStep() {
        return this.currentIndex === 0
      },
      // 是否是最后一步
      isLastStep() {
        return this.currentIndex === this.totalSteps - 1
      }
    },
    methods: {
      // 取消
      handleCancel() {
        this.$emit('cancel')
      },
      // 保存草稿
      handleSaveDraft() {
        this.$emit('save-draft')
      },
      // 上一步
      handlePrev() {
        this.$emit('prev')
      },
      // 下一步
      handleNext() {
        this.$emit('next')
      },
      // 提交
      handleSubmit() {
        this.$emit('submit')
      }
    }
  }
</script>

<template>
  <div class="operation-buttons">
    <!-- 取消按钮 -->
    <el-button @click="handleCancel">{{ cancelText }}</el-button>

    <!-- 保存草稿按钮 -->
    <el-button v-if="showSaveDraft" @click="handleSaveDraft">保存草稿</el-button>

    <!-- 上一步按钮 -->
    <el-button v-if="!isFirstStep && totalSteps > 1" @click="handlePrev">上一步</el-button>

    <!-- 下一步按钮 -->
    <el-button v-if="!isLastStep && totalSteps > 1" @click="handleNext">下一步</el-button>

    <!-- 提交按钮 -->
    <el-button type="primary" @click="handleSubmit">提交审核</el-button>
  </div>
</template>

<style scoped lang="scss">
  .operation-buttons {
    display: flex;
    justify-content: center;
    margin-top: 20px;

    .el-button {
      margin: 0 10px;
    }
  }
</style>
